import * as React from 'react';
import { SVGProps, memo } from 'react';

/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
const SvgSearchLocation = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    stroke="#007AFF"
    {...props}
  >
    <path d="m2.555 8.111 9.6-4.622-4.266 9.956-1.544-3.79-3.79-1.544Z" />
  </svg>
);
const Memo = memo(SvgSearchLocation);
export default Memo;
